export enum SellingTypeEnum {
    undefined = 0,
    auction = 1,
    classified = 2
}

export enum AuctionTypeEnum {
    unassigned = 0,
    auctionAndBuyNow = 1,
    buyNowOnly = 2
}

export enum VehicleTransferOptionsEnum{
    unassigned = 0,
    buyerMustPickUp = 1,
    buyerCanPickUp = 2,
    toBeArranged = 3
}